import script from "./StartGuide.vue?vue&type=script&setup=true&lang=ts"
export * from "./StartGuide.vue?vue&type=script&setup=true&lang=ts"

import "./StartGuide.vue?vue&type=style&index=0&id=9d256380&scoped=true&lang=css"

import exportComponent from "/home/fsilva/projetos/plate-vision-mobile-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d256380"]])

export default __exports__